import { User } from '@/core/models';
import { GET, PATCH, POST } from '@/lib/api/Methods';
import { TPartnerInfo } from '@/components/features/registration/templates/partner/types/template.types';
import { PartnerDashboardResponse, WebsiteLinkClickPayload } from './partner.types';
import { TManagePartnerProfile } from '@/components/layouts/landing/ManageProfile/partner/form/manage-partner-profile.validator';

export const createPartnerDetails = async (data: TPartnerInfo) =>
   POST<TPartnerInfo, User>('/auth/create-partner-details', data);

export const getPartnerDashboardStatistics = async () =>
   GET<never, PartnerDashboardResponse>('/user/partner-dashboard');

export const clickOnUrl = async (payload: WebsiteLinkClickPayload) =>
   POST<WebsiteLinkClickPayload, unknown>('user/partner-site-count', payload);

export const updatePartnerProfile = async (payload: TManagePartnerProfile) =>
   PATCH<TManagePartnerProfile, User>('/user/update-partner-profile', payload);
